module.exports = __webpack_public_path__ + "static/media/education-image.af30fb7f.webp";